import React from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ComingSoonModalBody,
  ComingSoonModalHeader,
  ComingSoonModalWrapper,
  ContinueButton,
} from './ComingSoon.styles';
import SmileyCar from '../../../assets/SmileyCar';

const ComingSoonModal = (props: {
  isOpen: boolean;
  closeModal: () => void;
}) => {
  const { isOpen, closeModal } = props;
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} headerText="Coming soon">
      <ComingSoonModalWrapper>
        <SmileyCar width={104} height={104} />
        <ComingSoonModalHeader>
          Good things are on the way&#33;
        </ComingSoonModalHeader>
        <ComingSoonModalBody>
          You clicked on a new feature that we’re soon introducing to your
          Carvana journey. Be sure to check back soon.
        </ComingSoonModalBody>
        <ContinueButton onClick={closeModal}>Continue</ContinueButton>
      </ComingSoonModalWrapper>
    </Modal>
  );
};
export default ComingSoonModal;
